module.exports = __webpack_public_path__ + "static/img/service-03.11ddf3d5.png";